import React from 'react'
import { components } from 'react-select'
import { Col } from 'react-bootstrap'
import { gql } from '@apollo/client'
import type { SelectAsyncProps } from '@ztechapps/webui.input'
import { SelectAsync } from '@ztechapps/webui.input'
import { HorizontalStack } from '@ztechapps/webui.util'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { LogisticStatus } from '../LogisticStatus/LogisticStatusBadge'

const logisticSelectFragment = gql`
  fragment logisticSelectFragment on Logistic {
    _id
    code
    summary
    status
    relatedLogistics {
      _id
    }
    vendor {
      _id
      company {
        _id
        name
      }
      profile {
        _id
        name
      }
    }
  }
`

export const queries = buildGraphqlQuery('Logistic', logisticSelectFragment)

//endregion

const Option = ({ data, ...rest }: any) => {
  const name = data?.vendor?.company?.name || '--'
  //always set the isSelected to false so it wont highlight
  return (
    <components.Option {...{ ...rest, data, isSelected: false }}>
      <HorizontalStack gap={2}>
        <div className="flex-shrink-0 text-nowrap">
          <HorizontalStack gap={0}>
            <LogisticStatus status={data?.status} />
            <div className="fw-bold">{data?.code}</div>
          </HorizontalStack>
        </div>

        <Col className="text-truncate">
          <small>{name}</small>
        </Col>
      </HorizontalStack>
    </components.Option>
  )
}

const dataLoadOptions = ({ filter }) => ({
  query: queries.allNoMetaConfig.query,
  filter: ({ input }) => ({
    $or: [{ code: { $regex: input, $options: 'i' } }, { summary: { $regex: input, $options: 'i' } }],
    ...filter,
  }),
  resultFieldName: 'allLogistic',
  options: () => ({
    sort: { createdAt: -1 as const },
  }),
})

export const LogisticSelect = ({ filter, ...rest }: SelectAsyncProps) => {
  return (
    <SelectAsync
      {...{
        ...rest,
        components: { Option },
        placeholder: 'Type logistic code or name',
        labelKey: 'code',
        noOptionsMessage: () => 'Cannot find any logistics.',
        dataLoadOptions: dataLoadOptions({ filter }),
      }}
    />
  )
}
